import { TFunction } from 'i18next'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { Body1 } from '@ui/Typography'
import { Link } from '@ui/components/Link'

import { NameDto } from '@model/NameDto'
import { CurrencyType } from '@model/WalletDto'

import { useDispatchOpenChat } from '@hooks/useDispatchOpenChat'
import { useFormatNumber } from '@hooks/useFormatNumber'

import { Box } from '@shared/components/Box'

export interface BalanceProps {
  platformType?: NameDto
  accountType?: NameDto
  balance: number
  currencyId: CurrencyType
  isDisabled: boolean
  freeMargin?: number
  isWallet?: boolean
  isTransferFrom?: boolean
  isTransferTo?: boolean
  onClose?: () => void
}

export const Balance: React.FC<BalanceProps> = (props) => {
  const { balance, platformType, accountType, currencyId, freeMargin, onClose } = props
  const { isDisabled, isWallet, isTransferFrom, isTransferTo } = props

  const { t } = useTranslation()
  const { formatMoney } = useFormatNumber()
  const { dispatchOpenChat, isLoading } = useDispatchOpenChat()

  const handleContactSupportClick = () => {
    dispatchOpenChat()
    onClose?.()
  }

  return (
    <Box flex direction='column' gap='x4'>
      {platformType && accountType && (
        <Body1 isParagraph>
          {platformType?.name} / {accountType?.name}
        </Body1>
      )}
      <Body1 isParagraph>
        {t('Wallet.Balance')}: {formatMoney(balance, currencyId)}
      </Body1>
      {freeMargin !== undefined && (
        <Body1 isParagraph>
          {t('Wallet.Available')}: {formatMoney(freeMargin, currencyId)}
        </Body1>
      )}
      {isDisabled && (
        <>
          <Body1 isParagraph color='text-primary-med-em'>
            {getRestrictionMessage(isTransferFrom, isTransferTo, isWallet, t)}
          </Body1>
          <div>
            {t('Please')}{' '}
            <Link disabled={isLoading} onClick={handleContactSupportClick}>
              {t('Contact Support').toLowerCase()}
            </Link>{' '}
            {t('for more info.')}
          </div>
        </>
      )}
    </Box>
  )
}

export const getRestrictionMessage = (
  isTransferFrom = false,
  isTransferTo = false,
  isWallet = false,
  t: TFunction
): string | undefined => {
  if (isWallet) {
    if (isTransferFrom) {
      return t('Transfer restricted from.TM Wallet')
    } else if (isTransferTo) {
      return t('Transfer restricted to.TM Wallet')
    }
  } else {
    if (isTransferFrom) {
      return t('Transfer restricted from.TM Trading Account')
    } else if (isTransferTo) {
      return t('Transfer restricted to.TM Trading Account')
    }
  }
}
